/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { extendObservable } from 'mobx';
import { createResourceStoreHouse } from 'src/luis/core/stores/resourceStoreHouse';
import { AppVersionStore } from 'src/luis/types/stores/apps/AppVersionStore';
import { AppVersionStoreHouse } from 'src/luis/types/stores/apps/AppVersionStoreHouse';
import { ResourceStoreHouse } from 'src/luis/types/stores/core/ResourceStoreHouse';
import { SubtractStore } from 'src/luis/types/SubtractStore';

/**
 * A factory function for creating an app version store house,
 * which houses an array of app version stores.
 */
export const createAppVersionStoreHouse = (): AppVersionStoreHouse => {
    const resourcesStoreHouse = createResourceStoreHouse<AppVersionStore>();

    const appVersionStoreHouse: SubtractStore<AppVersionStoreHouse, ResourceStoreHouse<AppVersionStore>> = {};

    return extendObservable(resourcesStoreHouse, appVersionStoreHouse, {}, { deep: false });
};
